<template>
    <modal :show.sync=show modalClasses="medium-sized-modal" :hide-footer="true">
        <h3 slot="header" class="mb-0 font-weight-500">Refinance</h3>

        <b-form @submit.prevent="submit">
            <b-row class="justify-content-center">
                <b-col cols="12" md="6">
                    <b-form-group label="Latest Market Value">
                        <CurrencyInput
                            v-model="form.remortgage_amount"
                            :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                        />
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group label="Latest Bank Outstanding">
                        <CurrencyInput
                            v-model="form.bank_outstanding"
                            :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="8" cols="12">
                    <b-button block variant="primary" class="mb-5" type="submit">Submit</b-button>
                </b-col>
            </b-row>
        </b-form>
    </modal>
</template>
<script>
import CurrencyInput from '@/components/CurrencyInput'
import solutionEventBus from '@/assets/js/EventBus/solutionEventBus.js'
import { useProductStore } from '@/stores/productStore'

export default {
    props: {
        refinancing_input:  Boolean
    },
    components: {
        CurrencyInput
    },
    data() {
        return {
            form: {
                remortgage_amount: 500000,
                bank_outstanding: 200000,
            }
        }
    },
    computed: {
        show: {
            get() {
                return this.refinancing_input;
            },
            set(value) {
                this.$emit('update:refinancing_input', value);
            }
        },
    },
    methods: {
        submit() {
            solutionEventBus.$emit('show-refinancing-bank')
            useProductStore().$patch({
                refinance_details: this.form,
                submit_refinance: true,
            })
            this.show = false
        }
    }
}
</script>